module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/thumbs/1-c22c17db9f0cf60c9a71487c9422281e.webp";